module.exports = __webpack_public_path__ + "img/forum-professional.176b72f2.svg";